import SvgAddressDefault from "../all-addresses/address/address-icons/SvgAddressDefault";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  isLoading?: boolean;
  disabled?: boolean;
  error?: boolean;
}

const AddressSubmitBtn: React.FC<Props> = ({
  isLoading = false,
  disabled = false,
  error = false,
}) => {
  const t = useTranslation();
  return (
    <div className="w-100">
      <CustomButton
        id="address-form"
        type={error ? BtnTypes.error : BtnTypes.primary}
        size={BtnSizes.large}
        radius={BtnRadius.small}
        isSubmit
        onClick={undefined}
        disabled={disabled}
        notAllowed={disabled}
        fullWidth
      >
        <SvgAddressDefault submit />
        {t.save}
        {isLoading && <SpinnerForBtn />}
      </CustomButton>
    </div>
  );
};

export default AddressSubmitBtn;
